function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  appearance: none;\n  border: none;\n  padding: 0;\n  background-color: transparent;\n  cursor: pointer;\n  width: 27px;\n  position: absolute;\n  z-index: 10;\n  top: 24px;\n  right: 24px;\n  fill: var(--dcm-modal-close-color, ",
        ");\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n      position: absolute;\n      left: 50%;\n      transform: translate(-50%, -50%);\n\n      ",
        " {\n        transform: translate(-50%, 0);\n        ",
        "\n      }\n    "
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  padding: 31px 47px 45px 47px;\n  background-color: var(--dcm-modal-bg, ",
        ");\n  border-radius: var(--dcm-modal-border-radius, 28px);\n  box-shadow: var(--dcm-modal-shadow, 0 5px 15px 0 rgba(0, 0, 0, 0.14));\n  min-height: 78px;\n  margin: 0 auto;\n  text-align: ",
        ";\n  top: 50%;\n  transform: translateY(-50%);\n\n  ",
        "\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n\n  ",
        " {\n    width: ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 50px;\n  width: 100%;\n  background-color: ",
        ";\n  border-radius: 0 0 var(--dcm-modal-border-radius, 28px) var(--dcm-modal-border-radius, 28px);\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import styled, { css } from 'styled-components';
import _ from 'lodash';
import { height, space, width, layout } from 'styled-system';
import ExitIcon from 'shared/assets/exit-icon';
export var ModalExitIcon = function(props) {
    return /*#__PURE__*/ _jsx(ModalExitIconStyles, _object_spread_props(_object_spread({
        "aria-label": "Close"
    }, props), {
        autoFocus: true,
        children: /*#__PURE__*/ _jsx(ExitIcon, {})
    }));
};
var ModalExitIconStyles = styled.button(_templateObject(), function(param) {
    var theme = param.theme;
    var _theme_colors;
    return theme === null || theme === void 0 ? void 0 : (_theme_colors = theme.colors) === null || _theme_colors === void 0 ? void 0 : _theme_colors.grey[45];
});
var Modal = styled.div.attrs(function(param) {
    var top = param.top;
    return {
        tabIndex: '-1',
        style: {
            top: top
        }
    };
})(_templateObject2(), function(param) {
    var theme = param.theme;
    var _theme_colors;
    return theme === null || theme === void 0 ? void 0 : (_theme_colors = theme.colors) === null || _theme_colors === void 0 ? void 0 : _theme_colors.white;
}, function(param) {
    var textAlign = param.textAlign;
    return textAlign;
}, function(param) {
    var isIframe = param.isIframe, _param_additionalMobileCSS = param.additionalMobileCSS, additionalMobileCSS = _param_additionalMobileCSS === void 0 ? '' : _param_additionalMobileCSS;
    return isIframe && css(_templateObject1(), function(param) {
        var theme = param.theme;
        var _theme_breakpoints;
        return theme === null || theme === void 0 ? void 0 : (_theme_breakpoints = theme.breakpoints) === null || _theme_breakpoints === void 0 ? void 0 : _theme_breakpoints.down('sm');
    }, additionalMobileCSS);
}, space, width, height, layout, function(param) {
    var theme = param.theme;
    var _theme_breakpoints;
    return theme === null || theme === void 0 ? void 0 : (_theme_breakpoints = theme.breakpoints) === null || _theme_breakpoints === void 0 ? void 0 : _theme_breakpoints.down('xs');
}, function(param) {
    var viewportWidth = param.viewportWidth;
    return viewportWidth ? "".concat(viewportWidth, "px") : "calc(100vw - 16px)";
});
/**
 * @type {React.FC<
 * {
 *  ref?: any;
 *  children?: React.ReactNode;
 *  parentOffset?: number | string;
 *  viewportHeight?: number | string;
 *  viewportWidth?: number | string;
 *  iframeHeight?: number | string | null;
 *  isIframe?: boolean;
 *  additionalMobileCSS?: string;
 *  onRequestClose?: () => void;
 *  textAlign?: string;
 * }
 * & import("styled-system").SpaceProps
 * & import("styled-system").LayoutProps
 * >}
 */ export var ModalContainer = /*#__PURE__*/ React.forwardRef(function(_param, ref) {
    var children = _param.children, _param_parentOffset = _param.parentOffset, parentOffset = _param_parentOffset === void 0 ? null : _param_parentOffset, _param_viewportHeight = _param.viewportHeight, viewportHeight = _param_viewportHeight === void 0 ? null : _param_viewportHeight, _param_viewportWidth = _param.viewportWidth, viewportWidth = _param_viewportWidth === void 0 ? null : _param_viewportWidth, _param_isIframe = _param.isIframe, isIframe = _param_isIframe === void 0 ? false : _param_isIframe, _param_iframeHeight = _param.iframeHeight, iframeHeight = _param_iframeHeight === void 0 ? null : _param_iframeHeight, _param_disableTopOffset = _param.disableTopOffset, disableTopOffset = _param_disableTopOffset === void 0 ? false : _param_disableTopOffset, _param_textAlign = _param.textAlign, textAlign = _param_textAlign === void 0 ? 'center' : _param_textAlign, props = _object_without_properties(_param, [
        "children",
        "parentOffset",
        "viewportHeight",
        "viewportWidth",
        "isIframe",
        "iframeHeight",
        "disableTopOffset",
        "textAlign"
    ]);
    var lower = viewportHeight / 2;
    var upper = iframeHeight - lower;
    var desktopOffset = isIframe ? _.clamp(parentOffset + lower, lower, upper) : null;
    var mobileOffset = isIframe ? _.clamp(parentOffset, 0, upper) : null;
    var isMobile = viewportWidth <= 900;
    var top = isMobile ? mobileOffset : desktopOffset;
    return /*#__PURE__*/ _jsx(Modal, _object_spread_props(_object_spread({
        ref: ref,
        top: disableTopOffset ? 0 : top,
        isIframe: isIframe,
        "data-cy": "modal-container",
        "data-testid": "modal-container",
        textAlign: textAlign
    }, props), {
        children: children
    }));
});
export var ModalFooter = styled.div(_templateObject3(), function(param) {
    var _param_includeBackgroundColor = param.includeBackgroundColor, includeBackgroundColor = _param_includeBackgroundColor === void 0 ? true : _param_includeBackgroundColor;
    return includeBackgroundColor ? "var(--dcm-modal-footer-bg, #f3f6f8)" : "inherit";
});
